import React, { FC, useContext } from 'react'
import { addGifs, fetchChannel } from 'shared/api/channels'
import Logger from 'shared/util/log'
import EditAPIContext from './edit-api'
import MessageContext from './message'
import RefreshDataContext from './refresh-data'

export const useSaveGifToCollection = () => {
    const { refreshChannel } = useContext(RefreshDataContext)
    const { sendMessage } = useContext(MessageContext)
    const saveGif = async (gifIds: (string | number)[], channelId: number) => {
        const suffix = gifIds.length > 1 ? 's' : ''
        try {
            const items = gifIds.map(gifId => ({
                gif: gifId,
                channel: channelId,
            }))
            await addGifs(items)
            Logger.info(`Channel ${channelId} updated, fire refresh`)
            // we probably don't need to fetch the channel here
            // since the added gif isn't reflected in a channel's data
            // but all we have is channel id and refreshChannel needs a channel
            refreshChannel(await fetchChannel(channelId), { deepRefresh: true })
            sendMessage(`GIF${suffix} added to collection`, 'success')
        } catch (e) {
            console.error(`Add gifs to channel error:`, e)
            sendMessage(`There was an error adding the GIF${suffix} to the collection`, 'error')
        }
    }
    return saveGif
}
type Props = {}

const EditAPIContextManager: FC<Props> = ({ children }) => {
    const saveGifsToCollection = useSaveGifToCollection()
    return <EditAPIContext.Provider value={{ saveGifsToCollection }}>{children}</EditAPIContext.Provider>
}

export default EditAPIContextManager
